import {
  createColDef,
  ItemGridFilterAnimationEnabled,
  ItemGridFilterTemplateType,
  TEMPLATE_TO_DISPLAY,
} from "@package/ui-apollo-components";
import {
  DeleteLayoutDocument,
  GetLayoutDocument,
  GetLayoutGridDocument,
  useGetLayoutGridQuery,
  type Layout,
  type Templates,
} from "@package/ui-gql/index-data-access";
import type { ColDef, ValueFormatterParams } from "ag-grid-community";
import { useMemo } from "react";
import { SidebarEntryPath } from "../../../../constants/contants";
import { useAppSelector } from "../../../../store/store";
import { ItemGridWithToolbar } from "../../../ItemGrid/ItemGridWithToolbar";

export function LayoutGrid() {
  const variables = useAppSelector((state) => state.itemGrid.layout.variables);

  const {
    data: dataLayouts,
    loading: loadingLayouts,
    error: errorLayouts,
  } = useGetLayoutGridQuery({ variables });

  const columnDefs = useMemo<ColDef[]>(
    () => [
      createColDef<Layout>("name", "Name", 1, 200),
      {
        ...createColDef<Layout>("template", "Template", 1, 200),
        sortable: false,
        valueFormatter: (params: ValueFormatterParams<Layout>) => {
          if (params.value) {
            return TEMPLATE_TO_DISPLAY[params.value as Templates];
          }

          return "";
        },
      },
      createColDef<Layout>("updatedAt", "Last Updated", 1, 125),
    ],
    [],
  );

  return (
    <ItemGridWithToolbar
      propsItemGrid={{
        sidebarEntryPath: SidebarEntryPath.layout,
        columnDefs,
        data: dataLayouts,
        error: !!errorLayouts,
        loading: !dataLayouts && loadingLayouts,
        filtersSupported: true,
        filterPanels: [
          <ItemGridFilterTemplateType key="template" />,
          <ItemGridFilterAnimationEnabled key="animationEnabled" />,
        ],
      }}
      propsItemGridToolbar={{
        title: "Layout",
        sidebarEntryPath: SidebarEntryPath.layout,
        createEnabled: true,
        deleteEnabled: true,
        deleteDocument: DeleteLayoutDocument,
        deleteRefetchQueries: [GetLayoutDocument, GetLayoutGridDocument],
        editEnabled: true,
      }}
    />
  );
}
